import {
  ACCEPT_INVITATION_FORM_EMAIL,
  ACCEPT_INVITATION_FORM_NAME,
} from '../../constants/ui.labels'
import Box from '@talkdesk/cobalt-react-box'
import { Group, GroupItem } from '@talkdesk/cobalt-react-input-group'
import Input from '@talkdesk/cobalt-react-input'
import Label from '@talkdesk/cobalt-react-label'

const AcceptInvitationForm = ({ name, email }) => (
  <Box>
    <Box paddingY='2'>
      <Label htmlFor='accept-invitation-name'>
        {ACCEPT_INVITATION_FORM_NAME}
      </Label>
    </Box>
    <Group isDisabled>
      <GroupItem>
        <Input
          id='accept-invitation-name'
          value={name}
          type='text'
          variation='unstyled'
          disabled
        />
      </GroupItem>
    </Group>
    <Box paddingY='2'>
      <Label htmlFor='accept-invitation-email'>
        {ACCEPT_INVITATION_FORM_EMAIL}
      </Label>
    </Box>
    <Group isDisabled>
      <GroupItem>
        <Input
          id='accept-invitation-email'
          value={email}
          type='text'
          variation='unstyled'
          disabled
        />
      </GroupItem>
    </Group>
  </Box>
)

export default AcceptInvitationForm
